import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { DialogSolutionDeployingComponent } from '@ebb-v2/ebb-integration';
import { SolutionHistoryApiService } from './data-services/solutionhistory-api.service';

import { AppLoadService} from '@ebb-v2/ebb-integration';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'ebb-portal';
  private dialogRef;
  public dialogRefCount = 0;

  constructor (
    private apiApp: AppLoadService,   
    private readonly dialogSolutionDeploying: MatDialog,
    private readonly apiSolutionHistory: SolutionHistoryApiService,
    private readonly router: Router
  ) {
      // console.log(`API: '${this.apiApp.readEnvironSettings().uriApi}'`);
      // console.log(`EBB: '${this.apiApp.readEnvironSettings().uriEbbFiles}'`);
      // console.log("app.component constructor");
      this.router.events
        .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
        .subscribe(event => {
          // console.log("event.id=" + event.id);
          // console.log("event.url=" + event.url);
          // console.log("event.urlAfterRedirects=" + event.urlAfterRedirects);
          // if ((event.id === 1 || event.id === 2) && event.url === event.urlAfterRedirects) {
            // console.log("checkSolutionDeploying");
            this.checkSolutionDeploying();
          // }
        });
  }
  
  // If a D365 solution is being deployed/imported, detect this and inform the user.
  private checkSolutionDeploying () {
    // //TEMPORARILY IMPLEMENT SOME CODE TO PERIODICALLY OPEN/CLOSE THE DIALOG, WITHOUT ACTUALLY CHECKING FOR SOLUTION DEPLOYMENT
    // if (this.dialogRefCount > 0) {
    //   this.dialogRefCount = 0;
    //   this.dialogRef.close();
    // } else {
    //   if (this.dialogRefCount <= 0) {
    //     this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
    //           width: '400px',
    //           disableClose: true
    //       }
    //     );
    //     this.dialogRefCount++;
    //   }
    // }
    // //END TEMPORARY CODE

    // Perform deployment status check, once.
    this.apiSolutionHistory
      .getSolutionHistoryList()
      .subscribe(
        solutionsApplying => {
          if (solutionsApplying.length > 0 && this.dialogRefCount <= 0) {
            this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
                  width: '400px',
                  disableClose: true
              }
            );
            this.dialogRefCount++;
          }
        },
        error => console.warn(`ERROR: app.component.checkSolutionDeploying() - ${error}`)
      );

      // Set up periodic deployment status checks.
      setInterval(
        () => {

          // //TEMPORARILY IMPLEMENT SOME CODE TO PERIODICALLY OPEN/CLOSE THE DIALOG, WITHOUT ACTUALLY CHECKING FOR SOLUTION DEPLOYMENT
          // if (this.dialogRefCount > 0) {
          //   this.dialogRefCount = 0;
          //   this.dialogRef.close();
          // } else {
          //   if (this.dialogRefCount <= 0) {
          //     this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
          //           width: '400px',
          //           disableClose: true
          //       }
          //     );
          //     this.dialogRefCount++;
          //   }
          // }
          // //END TEMPORARY CODE

          this.apiSolutionHistory
            .getSolutionHistoryList()
            .subscribe(
              solutionsApplying => {
                if (solutionsApplying.length <= 0 && this.dialogRefCount > 0) {
                  this.dialogRefCount = 0;
                  this.dialogRef.close();
                } else {
                  if (solutionsApplying.length > 0 && this.dialogRefCount <= 0) {
                    this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
                          width: '400px',
                          disableClose: true
                      }
                    );
                    this.dialogRefCount++;
                  }
                }
              },
              error => console.warn(`ERROR: app.component.checkSolutionDeploying() - ${error}`)
            );
        },
        60000
      );
  }
}
